import React, { useEffect, useRef } from "react";

// Procedurally builds an organic "stitch" line that draws itself on scroll into view.
export default function StitchDivider({ onInk = false }) {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    const height = 64;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", `0 0 1200 ${height}`);
    svg.setAttribute("preserveAspectRatio", "none");
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    const mid = height / 2;
    let d = `M 0 ${mid}`;
    const segments = 24;
    const segW = 1200 / segments;
    for (let i = 0; i < segments; i++) {
      const x = i * segW;
      const progress = i / segments;
      const amp = 8 + progress * 16;
      const dir = i % 2 === 0 ? -1 : 1;
      const cx1 = x + segW * 0.3;
      const cy1 = mid + dir * amp;
      const cx2 = x + segW * 0.7;
      const cy2 = mid - dir * amp * 0.6;
      const ex = x + segW;
      const ey = mid + (i % 4 === 0 ? dir * amp * 0.3 : 0);
      d += ` C ${cx1} ${cy1}, ${cx2} ${cy2}, ${ex} ${ey}`;
    }
    path.setAttribute("d", d);
    svg.appendChild(path);
    container.appendChild(svg);
    const len = path.getTotalLength();
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = len;
    path.style.transition = "stroke-dashoffset 1.6s cubic-bezier(.16,.8,.24,1)";
    const dio = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            path.style.strokeDashoffset = 0;
            dio.unobserve(container);
          }
        });
      },
      { threshold: 0.3 }
    );
    dio.observe(container);
    return () => {
      dio.disconnect();
      if (svg.parentNode === container) container.removeChild(svg);
    };
    // Mount-only: procedurally builds the SVG stitch once and observes it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={ref} className={`stitch-divider${onInk ? " on-ink" : ""}`} />;
}
